<script>
import Vue from 'vue'
import {mapActions} from "vuex";

export default Vue.extend({
  name: "referredClientsTable",
  data() {
    return {
      referredClients: [],
      referredClientsAdditional: [],
      totalReferredClients: 0,
      pageReferredClients: 1,
      sizeReferredClients: 25,
      moreDetailsDialog: false,
    }
  },
  methods: {
    ...mapActions("enquiry", ["getReferredClients"]),

    retrieveReferredClientList() {
      let params = {
        page: this.pageReferredClients,
        size: this.sizeReferredClients,
      }
      this.getReferredClients({params: params, callback: this.callback})
    },
    processClientAddress(value) {
      if (value.address && value.suburb && value.postcode && value.state) {
        return value.address + ' ' + value.suburb + ' ' + value.postcode + ' ' + value.state;
      }
      return 'N/A';
    },
    processClientFullName(value) {
      if (value.title && value.firstName && value.surname) {
        return value.title + ' ' + value.firstName + ' ' + value.surname;
      }
      return 'N/A';
    },
    handleCurrentChange(val) {
      this.pageReferredClients = val
      this.retrieveReferredClientList()
    },
    showDetail(key, val) {
      if (key == 1) {
        this.$router.push({path: '/uconnect/view', query: {pid: val.propertyId}})
      }
    },
    moreDetailsOnReferredClient(row) {
      this.moreDetailsDialog = true;
      this.referredClientsAdditional = row;
    },
    truncateQuestion(value) {
      if (value && value.length > 25) {
        return value.substring(0, 25) + '...';
      }
      return value;
    },
    processPropertyAddress(value) {
      if (value.propertyAddress && value.propertySuburb && value.propertyPostcode && value.propertyState) {
        return value.propertyAddress + ' ' + value.propertySuburb + ' ' + value.propertyPostcode + ' ' + value.propertyState;
      }
      return 'N/A';
    },
    callback(resp, status) {
      switch (status) {
        case 'getReferredClientsCallback':
          if (resp.code == 0) {
            this.totalReferredClients = resp.data.totalRecord
            this.referredClients = resp.data.list
          } else {
            Utils.alert('', resp.message, 'error')
          }
          break;
        default:
          break;
      }
    },
    formatCurrency(value) {
      if (value === null || value === undefined || isNaN(Number(value))) {
        return 'N/A';
      }
      return new Intl.NumberFormat('en-AU', {
        style: 'currency',
        currency: 'AUD',
      }).format(value);
    },
  },
  mounted() {
    this.retrieveReferredClientList()
  },
})
</script>

<template>
  <div>
    <el-table
      :data="referredClients"
      style="width: 100%;">
      <el-table-column
        prop="clientName"
        min-width="150"
        label="Client Name">
      </el-table-column>
      <el-table-column
        prop="contactNumber"
        min-width="150"
        label="Contact Number">
      </el-table-column>
      <el-table-column
        prop="email"
        min-width="200"
        label="Email">
      </el-table-column>
      <el-table-column
        prop="propertyId"
        min-width="150"
        label="Property Address">
        <template v-slot="scope">
          <span>{{ processPropertyAddress(scope.row) }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="clientBudget"
        min-width="150"
        label="Client Budget">
        <template v-slot="scope">
          <span>{{ formatCurrency(scope.row.clientBudget) }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="reason"
        min-width="200"
        label="Reason">
        <template v-slot="scope">
          <span>{{ truncateQuestion(scope.row.reason) }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="comment"
        min-width="200"
        label="Comment">
        <template v-slot="scope">
          <span>{{ truncateQuestion(scope.row.comment) }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="propertyId"
        min-width="300"
        label="Actions">
        <template v-slot="scope">
          <el-button class="btn-link" @click="moreDetailsOnReferredClient(scope.row)" type="text" icon="el-icon-more-outline">More
          </el-button>
          <span class="divider"> | </span>
          <el-button class="btn-link" @click="showDetail(1,scope.row)" type="text" icon="el-icon-view">View
            Property
          </el-button>
<!--          <span class="divider"> | </span>-->
<!--          <el-button class="btn-link" @click="handleDelete(scope.row)" type="text" icon="el-icon-delete">Remove-->
<!--          </el-button>-->
        </template>
      </el-table-column>
    </el-table>
    <div class="fen" v-if="totalReferredClients">
      <el-pagination
        @current-change="handleCurrentChange"
        :current-page="pageReferredClients"
        :page-size="25"
        layout="total, prev, pager, next"
        :total="totalReferredClients">
      </el-pagination>
    </div>

    <!-- More Details Dialog -->
    <el-dialog
      title="Referred Client Details"
      :visible.sync="moreDetailsDialog"
      :append-to-body="true"
      class="referred-client-dialog"
      :show-close="false"
      center
      width="500px">
      <template v-slot class="dialog-body">
        <el-row>
          <el-col :span="24">
            <el-row :gutter="10" style="padding: 3px 0">
              <el-col :span="8" style="text-align: right">
                <span>Client Name: </span>
              </el-col>
              <el-col :span="16" style="text-align: left">
                <span style="font-weight: 600">{{ referredClientsAdditional.clientName }}</span>
              </el-col>
            </el-row>
            <el-row :gutter="10" style="padding: 3px 0">
              <el-col :span="8" style="text-align: right">
                <span>Contact Number: </span>
              </el-col>
              <el-col :span="16" style="text-align: left">
                <span style="font-weight: 600">{{ referredClientsAdditional.contactNumber }}</span>
              </el-col>
            </el-row>
            <el-row :gutter="10" style="padding: 3px 0">
              <el-col :span="8" style="text-align: right">
                <span>Email: </span>
              </el-col>
              <el-col :span="16" style="text-align: left">
                <span style="font-weight: 600">{{ referredClientsAdditional.email }}</span>
              </el-col>
            </el-row>
            <el-row :gutter="10" style="padding: 3px 0">
              <el-col :span="8" style="text-align: right">
                <span>Your Name: </span>
              </el-col>
              <el-col :span="16" style="text-align: left">
                <span style="font-weight: 600">{{ referredClientsAdditional.yourName }}</span>
              </el-col>
            </el-row>
            <el-row :gutter="10" style="padding: 3px 0">
              <el-col :span="8" style="text-align: right">
                <span>Client Budget: </span>
              </el-col>
              <el-col :span="16" style="text-align: left">
                <span style="font-weight: 600">{{ formatCurrency(referredClientsAdditional.clientBudget) }}</span>
              </el-col>
            </el-row>
            <el-row :gutter="10" style="padding: 3px 0">
              <el-col :span="8" style="text-align: right">
                <span>Client Name: </span>
              </el-col>
              <el-col :span="16" style="text-align: left">
                <span style="font-weight: 600">{{ referredClientsAdditional.clientName }}</span>
              </el-col>
            </el-row>
            <el-row :gutter="10" style="padding: 3px 0">
              <el-col :span="8" style="text-align: right">
                <span>Reason: </span>
              </el-col>
              <el-col :span="16" style="text-align: left">
                <span style="font-weight: 600">{{ referredClientsAdditional.reason }}</span>
              </el-col>
            </el-row>
            <el-row :gutter="10" style="padding: 3px 0">
              <el-col :span="8" style="text-align: right">
                <span>Comment: </span>
              </el-col>
              <el-col :span="16" style="text-align: left">
                <span style="font-weight: 600">{{ referredClientsAdditional.comment }}</span>
              </el-col>
            </el-row>
            <el-row :gutter="10" style="padding: 3px 0">
              <el-col :span="24" style="text-align: center; padding: 20px 0 5px 0">
                <span style="font-weight: 600; font-size: 16px">Client Details for the Reservation</span>
              </el-col>
            </el-row>
            <el-row :gutter="10" style="padding: 3px 0">
              <el-col :span="8" style="text-align: right">
                <span>Name: </span>
              </el-col>
              <el-col :span="16" style="text-align: left">
                <span style="font-weight: 600">{{ processClientFullName(referredClientsAdditional) }}</span>
              </el-col>
            </el-row>
            <el-row :gutter="10" style="padding: 3px 0">
              <el-col :span="8" style="text-align: right">
                <span>Address: </span>
              </el-col>
              <el-col :span="16" style="text-align: left">
                <span style="font-weight: 600">{{ processClientAddress(referredClientsAdditional) }}</span>
              </el-col>
            </el-row>
            <el-row :gutter="10" style="padding: 3px 0">
              <el-col :span="8" style="text-align: right">
                <span>Email: </span>
              </el-col>
              <el-col :span="16" style="text-align: left">
                <span style="font-weight: 600">{{ referredClientsAdditional.emailAdditional ? referredClientsAdditional.emailAdditional : 'N/A' }}</span>
              </el-col>
            </el-row>
            <el-row :gutter="10" style="padding: 3px 0">
              <el-col :span="8" style="text-align: right">
                <span>Phone: </span>
              </el-col>
              <el-col :span="16" style="text-align: left">
                <span style="font-weight: 600">{{ referredClientsAdditional.phone ? referredClientsAdditional.phone : 'N/A' }}</span>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
      </template>
      <template v-slot:footer class="dialog-footer">
        <el-row :gutter="20">
          <el-col :span="24">
            <el-button type="primary" @click="moreDetailsDialog = false"
                       style="background:#003333;border:none;width:100%;">Close
            </el-button>
          </el-col>
        </el-row>
      </template>
    </el-dialog>
  </div>
</template>

<style scoped lang="scss">
.btn-link {
  color: rgba(0, 51, 51, 0.9);
  font-family: 'DINosaur-a', sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  text-decoration-line: underline;
}

.btn-link:hover {
  color: #003333;
}

.referred-client-dialog .el-dialog__header {
  padding: 10px !important;
}
.referred-client-dialog .el-dialog__title {
  font-size: 24px;
}
</style>



// WEBPACK FOOTER //
// src/components/enquiry/referredClientsTable.vue